import React from "react";

/**
 * NeuralWord wraps a keyword in a paragraph and:
 * - Styles it with the `neural-text` underline + glow
 * - On hover, calls window.__auraNeural.pulseElement(el) so the canvas fires from this word
 */
const NeuralWord = ({ children, intensity = 0.9, as: Tag = "span", ...rest }) => {
  const ref = React.useRef(null);

  const trigger = React.useCallback(() => {
    if (typeof window !== "undefined" && window.__auraNeural) {
      window.__auraNeural.pulseElement(ref.current, intensity);
    }
  }, [intensity]);

  return (
    <Tag
      ref={ref}
      className="neural-text"
      onMouseEnter={trigger}
      onFocus={trigger}
      data-cursor="hover"
      tabIndex={0}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default NeuralWord;
